<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/event' }">
        <app-i18n code="entities.event.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.event.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.event.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.event.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.event.new.title" v-if="!isEditing"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.title.label"
          :prop="fields.title.name"
          :required="fields.title.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.title.name]" ref="focus" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.description.label"
          :prop="fields.description.name"
          :required="fields.description.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.description.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.date.label"
          :prop="fields.date.name"
          :required="fields.date.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-date-picker placeholder type="datetime" v-model="model[fields.date.name]"></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.hour.label"
          :prop="fields.hour.name"
          :required="fields.hour.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.hour.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.duration.label"
          :prop="fields.duration.name"
          :required="fields.duration.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.duration.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.location.label"
          :prop="fields.location.name"
          :required="fields.location.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input v-model="model[fields.location.name]" />
          </el-col>
        </el-form-item>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="common.save"></app-i18n>
            </el-button>

            <!-- <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
            </el-button> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { EventModel } from '@modules/event/event-model';

const { fields } = EventModel;
const formSchema = new FormSchema([
  fields.id,
  fields.title,
  fields.description,
  fields.date,
  fields.hour,
  fields.duration,
  fields.location,
]);

export default {
  name: 'app-event-form-page',

  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'event/form/record',
      findLoading: 'event/form/findLoading',
      saveLoading: 'event/form/saveLoading',
    }),

    isEditing() {
      return !!this.id;
    },

    fields() {
      return fields;
    },
  },

  async created() {
    if (this.isEditing) {
      await this.doFind(this.id);
    } else {
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'event/form/doFind',
      doNew: 'event/form/doNew',
      doUpdate: 'event/form/doUpdate',
      doCreate: 'event/form/doCreate',
    }),

    doReset() {
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {
        return this.doCreate(values);
      }
    },
  },
};
</script>

<style>
</style>
